export default "__VITE_ASSET__8bdb9fe2__"